<template>
<div v-if="ajaxFlag">
    <bg :bg="coupon.bg"></bg>
    <return-btn></return-btn>
    <div class="wrap">
        <div class="main">
            <div class="hbtop">
                <div class="inner">
                    <p v-if="coupon.successFlag" class="coupontip">
                        <span v-if="!coupon.tipFlag">恭喜您获得<span class="coupon-tipred">{{coupon.couponlist ? coupon.couponlist.length : 0}}</span>张代金券</span>
                        <span v-if="coupon.tipFlag">{{textTip}}</span>
                    </p>
                    <p v-if="coupon.failFlag && coupon.tip" class="coupontip">{{coupon.tip}}</p>
                    <success :couponlist="coupon.couponlist" v-if="coupon.successFlag"></success>
                    <fail v-if="coupon.failFlag"></fail>
                </div>
                <img src="//static.daojia.com/fe/jz/daojiaapp/hongbao/image/side.1d330e17.png" class="hbw" alt="">
            </div>
            <div class="hbbottom">
                <div class="userinfo">
                    <info :info="coupon.content"></info>
                </div>
                <ul class="list">
                    <!-- <rule :rule="coupon.rule"></rule> -->
                    <li class="ruleCity" @click="showRuleEvent">{{coupon.rule.tit}}</li>
                    <li class="application app2" @click="showAboutEvent" v-if="coupon.introFlag">{{coupon.introtit}}</li>
                    <!-- <about :intro="coupon.intro" :introtit="coupon.introtit" v-if="coupon.introFlag"></about> -->
                </ul>
                <ul class="btn" v-if="downloadInfo.flag">
                    <li class="button1" v-if="coupon.button1">
                        <a href="javascript:;" v-if="coupon.button1.type == 0" @click="btnClickEvent(coupon.button1.url)">{{coupon.button1.name}}</a>
                        <a href="javascript:;" v-if="coupon.button1.type == 1" @click="shareEvent(coupon.button1)">{{coupon.button1.name}}</a>
                    </li>
                    <li class="button2" v-if="coupon.button2" :class="{'btnBotNo':!coupon.button1}">
                        <div class="btnzdy" v-if="coupon.button2.type == 0">
                            <a :href="coupon.button2.url">{{coupon.button2.name}}</a>
                        </div>
                        <div class="btnzdy" v-if="coupon.button2.type == 1">
                            <a href="javascript:;" @click="shareEvent(coupon.button2)">{{coupon.button2.name}}</a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="result_blank">
        <img :src="activityBg" alt="" />
    </div>
    <download :info="downloadInfo" v-if="downloadInfo.flag"></download>
    <btn v-if="!downloadInfo.flag" :button1="coupon.button1" :button2="coupon.button2" :show="maskFlag"></btn>
    <loading v-if="loading"></loading>
    <div class="toast" v-show="tipFlagToast">
        <p>{{textTip}}</p>
    </div>
    <rule :rule="coupon.rule" v-if="ruleFlag"></rule>
    <about :intro="coupon.intro" :introtit="coupon.introtit" v-if="aboutFlag"></about>
    <share-mask v-if="shareFlag" :share="sharedata"></share-mask>
</div>
</template>
<script>
import Loading from './base/Loading.vue';
import Rule from './base/Rule.vue';
import About from './base/About.vue';
import Bg from './base/Bg.vue';
import ReturnBtn from './base/ReturnBtn.vue';
import Success from './base/Success.vue';
import Fail from './base/Fail.vue';
import Btn from './base/Btn.vue';
import Info from './base/Info.vue';
import Download from './base/Download.vue';
import storageSupport from '../tools/storageSupport.js';
import ShareMask from './base/ShareMask.vue';
import utils from '@/tools/utils.js'
import {trackPageviewObject} from '@/tools/track.js'
import {miniBack} from '@/tools/miniback.js'
export default {
    props: {
        pagedata: Object
    },
    data() {
        var bg
        if (window.resultCouponBackgroud) {
            bg = window.resultCouponBackgroud
        } else {
            if (storageSupport && sessionStorage.getItem('resultCouponBackgroud')) {
                bg = sessionStorage.getItem('resultCouponBackgroud')
            } else {
                bg = '//images.daojia.com/jz/pic/c98147efea407f45a99035ba59013aae.png'
            }
        }
        var activityBg
        if(window.activityInfoBackground) {
            activityBg = window.resultCouponBackground
        }

        var res
        if (window.ActivityResultData) {
            res = window.ActivityResultData
        } else {
            if (sessionStorage.getItem('ActivityResultData')) {
                res = JSON.parse(sessionStorage.getItem('ActivityResultData'))
            } else {
                res = ''
            }
        }
        var failFlag = false
        var successFlag = false
        if (res.code == 0) {
            var type = parseInt(res.data.type);
            if (type == 0 || type == 1) {
                successFlag = true;
            } else if (type == 2) {
                failFlag = true;
            }
        } else {
            failFlag = true;
        }
        var button1Url

        if (window.isAppFlag) {
            button1Url = 'daojia://gotoHomepage/achieveFuncational';
        }else {
            button1Url = 'https://jzt.daojia.com/weixinwallet/index?hmsr=wxwallet&channel=wxwallet&comm_pf=skinforwxwallet.css';
        }

        return {
            textTip: '这是您已领过的代金券哦~',
            tipFlagToast: false,
            errorFlag: false,
            loading: false,
            ruleFlag: false,
            aboutFlag: false,
            ajaxFlag: false,
            disabledFlag: true,
            maskFlag: false,
            shareFlag: false,
            sharedata: null,
            downloadInfo: {
                logo: 'https://images.daojia.com/jz/pic/97e3b19805fee9f57e4bed2b8dd76d64.png',
                content: '天鹅到家\r\n专业便捷安心的上门服务平台',
                url: window.downloadUrl,
                flag: false
            },
            coupon: {
                res: res,
                uid: '',
                phone: '',
                // content: '1.下载天鹅到家APP；\r\n2.点击“我的-代金券”即可查看使用~',
                content: '',
                couponlist: null,
                buttonlist: null,
                bg: bg,
                rule: window.rule,
                intro: window.intro,
                introtit: window.introtit,
                introFlag: false,
                tipFlag: false,
                tip: '',
                successFlag: successFlag,
                failFlag: failFlag,
                shareFlag: false,
                btnLink: {
                    type: 0,
                    name: '预约到家服务',
                    url: button1Url
                },
                btnShare: {
                    type: 1,
                    name: '分享给好友',
                    url: 'static.daojia.com/fe/jz/daojiaapp/hongbao/image/sharke.png'
                },
                button1: {
                    type: 0,
                    name: '预约到家服务',
                    url: button1Url
                },
                button2: null
            }
        }
    },
    created() {
        var that = this;
        // window.Back.reset();
        // window.Back.push(function() {
        //     window.history.back();
        // });
        that.fetchData();
        trackPageviewObject({
            'page_type': 'bjhongbao_coupon',
            'page_name': 'bjhongbao_coupon_bind_success',
            'templateid': utils.urlParam('templateid')
        })
    },
    ready() {
        var that = this;
        document.body.removeAttribute('style');
    },
    events: {
        ruleFlagEvent() {
            var that = this;
            that.ruleFlag = false;
        },
        aboutFlagEvent() {
            var that = this;
            that.aboutFlag = false;
        },
        hideEvent() {
            var that = this;
            that.shareFlag = false;
        }
    },
    methods: {
        // 活动规则遮罩显示
        showRuleEvent() {
            var that = this;
            that.ruleFlag = true;
        },
        // 关于我们遮罩显示
        showAboutEvent() {
            var that = this;
            that.aboutFlag = true;
        },
        // 渲染页面，数据从首页存到的sessionStorage中获取
        fetchData() {
            var that = this;
            that.ajaxFlag = true;
            if (that.coupon.res && parseInt(that.coupon.res.code) == 0) {
                var data = that.coupon.res.data;
                if (data) {
                    var type = parseInt(data.type);
                    switch (type) {
                        case 0: //领取成功
                            that.coupon.successFlag = true;
                            that.coupon.tipFlag = false;
                            that.tipFlagToast = false;
                            break;
                        case 1: //已领取
                            that.coupon.successFlag = true;
                            that.coupon.tipFlag = true;
                            that.tipFlagToast = true;
                            setTimeout(function() {
                                that.tipFlagToast = false
                            }, 2000)
                            break;
                        case 2: //不符合规则
                            that.coupon.failFlag = true;
                            if (data.failReason) {
                                that.coupon.tip = data.failReason;
                            } else {
                                that.coupon.tip = that.coupon.res.msg;
                            }
                            break;
                    }
                    if (data.uid) {
                        that.coupon.uid = data.uid;
                    }
                    if (data.phone) {
                        that.coupon.phone = data.phone;
                    }
                    if (data.content) {
                        that.coupon.content = data.content;
                    }
                    if (data.backgroud) {
                        that.coupon.bg = data.backgroud;
                    }
                    if (data.couponList) {
                        that.coupon.couponlist = data.couponList;
                    }

                    if (data.button1) {
                        var item = data.button1;
                        if (parseInt(item.type) == 0) { //跳转
                            that.coupon.button1 = {};
                            that.coupon.button1.type = 0;
                            that.coupon.button1.name = item.name ? item.name : that.coupon.btnLink.name;
                            that.coupon.button1.url = item.url ? item.url : that.coupon.btnLink.url;
                            var reg = /^daojia:.+/.test(that.coupon.button1.url)
                            if (window.isAppFlag && !reg) {
                                that.coupon.button1.url = 'daojia://openUrl/jumpPage?url=' + encodeURIComponent(that.coupon.button1.url);
                            }
                        } else if (parseInt(item.type) == 1) { //分享
                            //为了兼容线上的情况，用户没有填写分享信息，则为默认的跳转
                            if (!item.name || !item.url) {
                                that.coupon.button1 = {};
                                that.coupon.button1.type = 0
                                that.coupon.button1.name = item.name ? item.name : that.coupon.btnLink.name;
                                that.coupon.button1.url = item.url ? item.url : that.coupon.btnLink.url;
                            } else {
                                that.coupon.button1 = {};
                                that.coupon.button1.type = 1;
                                that.coupon.button1.name = item.name ? item.name : that.coupon.btnLink.name;
                                that.coupon.button1.url = item.url ? item.url : that.coupon.btnLink.url;
                            }
                        } else if (parseInt(item.type) == 2) { //不显示
                            that.coupon.button1 = null;
                        }
                    }
                    if (data.button2) {
                        var item = data.button2;
                        if (parseInt(item.type) == 0) { //跳转
                            //为了兼容线上的情况，用户没有填写跳转信息，则为默认的分享
                            if (!item.name || !item.url) {
                                that.coupon.button2 = {};
                                that.coupon.button2.type = 1;
                                that.coupon.button2.name = item.name ? item.name : that.coupon.btnShare.name;
                                that.coupon.button2.url = item.url ? item.url : that.coupon.btnShare.url;
                            } else {
                                that.coupon.button2 = {};
                                that.coupon.button2.type = 0;
                                that.coupon.button2.name = item.name ? item.name : that.coupon.btnShare.name;
                                that.coupon.button2.url = item.url ? item.url : that.coupon.btnShare.url;
                                var reg = /^daojia:.+/.test(that.coupon.button2.url)
                                if (window.isAppFlag && !reg) {
                                    that.coupon.button2.url = 'daojia://openUrl/jumpPage?url=' + encodeURIComponent(that.coupon.button2.url);
                                }
                            }
                        } else if (parseInt(item.type) == 1) { //分享
                            that.coupon.button2 = {};
                            that.coupon.button2.type = 1;
                            that.coupon.button2.name = item.name ? item.name : that.coupon.btnShare.name;
                            that.coupon.button2.url = item.url ? item.url : that.coupon.btnShare.url;
                        } else if (parseInt(item.type) == 2) { //不显示
                            that.coupon.button2 = null;
                        }
                    }
                    if (data.rule && data.rule.ruleTitle) {
                        that.coupon.rule.tit = data.rule.ruleTitle;
                    }
                    if (data.rule && data.rule.ruleContent) {
                        that.coupon.rule.con = data.rule.ruleContent;
                    }
                    if (data.introduce && data.introduce.content) {
                        that.coupon.intro = data.introduce.content;
                    }
                    if (data.introduce && data.introduce.title) {
                        that.coupon.introtit = data.introduce.title;
                    }
                    if (data.introduce && parseInt(data.introduce.type) == 0) {
                        that.coupon.introFlag = true;
                    }
                    if (data.content) {
                        that.coupon.content = data.content;
                    }
                    if (parseInt(data.downloadNeed) == 0) {
                        window.isAppFlag ? that.downloadInfo.flag = false : that.downloadInfo.flag = true
                    } else if (parseInt(data.downloadNeed) == 1) {
                        window.isAppFlag ? that.downloadInfo.flag = false : that.downloadInfo.flag = true
                    }
                    if (data.download) {
                        if (parseInt(data.download.downloadNeed) == 0) {
                            // 默认天鹅到家
                            window.isAppFlag ? that.downloadInfo.flag = false : that.downloadInfo.flag = true
                        } else if (parseInt(data.download.downloadNeed) == 1) {
                            // 不需要
                            that.downloadInfo.flag = false
                        } else if (parseInt(data.download.downloadNeed) == 2) {
                            // 自主配置
                            that.downloadInfo.flag = true
                            // window.isAppFlag ? that.downloadInfo.flag = false : that.downloadInfo.flag = true
                            that.downloadInfo.content = data.download.downloadButtonContent
                            that.downloadInfo.url = data.download.downloadButtonUrl
                            that.downloadInfo.logo = data.download.downloadButtonLogo
                        }
                    }
                    if (data.share && parseInt(data.share.type) == 0) { //配置分享
                        var share = data.share;
                        // window.setRightButtons(window.rightButtons);
                        var shareimg = share.imgUrl ? share.imgUrl : window.shareAppData.iconUrl;
                        var sharetit = share.title ? share.title : window.shareAppData.title;
                        var sharecon = share.content ? share.content : window.shareAppData.content;
                        window.shareEvent(shareimg, sharetit, sharecon);
                        if (share.imgUrl) {
                            window.shareAppData.iconUrl = share.imgUrl
                        }
                        if (share.title) {
                            window.shareAppData.title = share.title
                        }
                        if (share.content) {
                            window.shareAppData.content = share.content
                        }
                    } else if (data.share && parseInt(data.share.type) == 1) { //禁用分享
                        that.shareDefault();
                    }
                } else {
                    that.coupon.tip = that.coupon.res.msg ? t.coupon.res.msg : '服务器繁忙，请稍后再试～';
                    that.shareDefault();
                }
            } else {
                that.shareDefault();
                that.coupon.tip = '服务器繁忙，请稍后再试～';
            }
        },
        //点击预约保洁
        btnClickEvent(jumpUrl){
            console.log("jumpUrl is: " + jumpUrl)
            if(window.channel && window.channel == 'webChat'){
                //如果judgeSource == 'activity' 在小程序中点击领券其他优惠券时跳到活动主会场 否则跳到小程序首页
                if(window.judgeSource && window.judgeSource == 'activity'){
                    window.location.href=jumpUrl;
                }else{
                    // wx.miniProgram.navigateTo({url:'/pages/index/index'});
                    miniBack()
                }
            }else{
                window.location.href=jumpUrl;
                //alert('其他'+jumpUrl);
            }
        },
        //点击预约保洁
        // btnClickEvent(jumpUrl){
        //     if (typeof wx == 'object'){
        //         wx.miniProgram.getEnv(function(res) {
        //             if (res.miniprogram){   // 小程序环境
        //                 wx.miniProgram.navigateTo({url:'/pages/index/index'});
        //             }else{
        //                 window.location.href=jumpUrl;
        //             }
        //         })
        //     }else{
        //         window.location.href=jumpUrl;
        //     }
        // },
        //点击分享
        shareEvent(buttondata) {
            console.log(`share log${JSON.stringify(buttondata)}`)
            var that = this;
            that.shareFlag = true;
            that.sharedata = buttondata;
            that.$dispatch('maskFlagEvent', true);
        },
        shareDefault() {
            var that = this;
            window.shareHide();
            window.setRightButtons(window.rightButtonsHide);
        }
    },
    components: {
        Loading,
        Rule,
        About,
        Bg,
        Success,
        Fail,
        Btn,
        Info,
        Download,
        ShareMask,
        ReturnBtn
    }
}
</script>
<style>
.coupon-tipred {
    color: #f74951;
}

.toast {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0);
    z-index: 11;
}

.toast p {
    width: 230px;
    padding: 20px 0;
    font-size: 16px;
    color: #fff;
    background: rgba(0, 0, 0, .65);
    border-radius: 5px;
    position: absolute;
    text-align: center;
    top: 50%;
    left: 50%;
    -webkit-transform:translate(-50%,-50%);
    -moz-transform:translate(-50%,-50%);
    -ms-transform:translate(-50%,-50%);
    -o-transform:translate(-50%,-50%);
    transform:translate(-50%,-50%);
}

.result_blank {
    height: 12rem;
}
</style>



// WEBPACK FOOTER //
// Result.vue?3ed7c510